import http from '../httpConfig'
const table = "mrbase_sys_directory"
export const file_tree = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/directory/treeListAll/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const get_file = (params = {}) => {
    params['~table~'] = "mrbase_sys_document"
    return new Promise((resolve, reject) => {
        http.post('/api/document/getButtonPermissions/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const add_file = (params = {}) => {
    params['~table~'] = "mrbase_sys_document"
    return new Promise((resolve, reject) => {
        http.post('/api/document/addDocument/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const del_file = (params = {}) => {
    params['~table~'] = "mrbase_sys_document"
    return new Promise((resolve, reject) => {
        http.post('/api/document/delDocument/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const rename = (params = {}) => {
    params['~table~'] = "mrbase_sys_document"
    return new Promise((resolve, reject) => {
        http.post('/api/document/upDocumentName/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const popBoxGetFileDirectory = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/document/popBoxGetFileDirectory/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const fileMoveTo = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/document/fileMoveTo/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}